<template>
  <div class="welcome-page common-page-main main-page">
    <div class="field-box content-wrap scroll-cotar">
      <div class="top-bar">
        Note! The system browser is recommended to run: IE9 or more:
        <a class="down-link" href="https://www.baidu.com/link?url=4eO8r116y7VARgZMmtD5BCAEp06bHehAK4a9m2l_BDgmyJxkTfv8NEDDwhN797O4CE86SCEJwoYmOrHIhVTSi359id0geXzoDsPdRuVe09C&amp;wd=&amp;eqid=d3c069f80002a6d9000000035719f91e" target="_blank">Google Chrome ,</a>
        <a class="down-link" href="https://www.baidu.com/link?url=dUrZ_7TO3Aw0T7Li31vES6hcLmjkP7DxhF3pKLSxClhR7R4FX16LLdPqaR6wGCjugB_EgBgh5Pfh8UPreifyDBgi-LB3JBr5n4yH1vaS9ty&amp;wd=&amp;eqid=e3103e1b00001f250000000359bfca00" target="_blank">Firefox browser</a>
        In order to achieve the best operating results
      </div>
      <div class="quick-nav">
        <div class="nav-list">
          <el-row :gutter="10">
            <el-col :span="4" v-for="(item, i) in menuNav" :key="i">
              <router-link class="item" :to="item.MoUrl">
                <div class="vm-cotar">{{item.MoName}}</div>
              </router-link>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="contact-info-wrap">
        <table class="contact-info-tab">
          <tbody class="contact-info">
            <WelcomeForm @updateSuccess="handleUpdate" ref="popForm"></WelcomeForm>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
// import tools from '@/components/common/tools'
import tools from '@/components/common/tools'
import WelcomeForm from '@/components/other/WelcomeForm'

// 请求相关操作
let page = {
  methods: {
    getDataAjax() {
      tools.commonAjax.call(this, true, '/Ajax/GetConfigInfoInCommon', {
      }).then((res) => {
        this.$refs.popForm.setValue(res.data)
      })
    }
  }
}

export default {
  name: 'Welcome',
  mixins: [page],
  components: {
    WelcomeForm
  },
  mounted() {
  },
  created() {
    this.getDataAjax()
  },
  data() {
    return {
    }
  },
  computed: {
    // 导航菜单
    menuNav() {
      return this.$store.getters.quickNavModuleData
    }
  },
  methods: {
    // 修改操作
    handleUpdate() {
      // 刷新表格数据
      this.getDataAjax()
    }
  }
}
</script>

<style lang='scss'>
@import '~@/style/common';
.welcome-page {
  .top-bar {
    padding: 10px;
    line-height: 20px;
    background: #f3dfdf;
    color: #ba4a48;
    .down-link {
      height: 20px;
      line-height: 20px;
      border-right: 1px solid #dedede;
      display: inline-block;
      color: #0089ce;
    }
  }
  .quick-nav {
    margin: 20px 0;
    border: 1px solid $c_nc_4;
    .headline {
      padding: 15px 0;
      line-height: 60px;
      font-size: 26px;
      text-align: center;
      color: #323271;
      background-color: $c_nc_2;
    }
  }
  .nav-list {
    padding: 5px 10px;
    min-height: 160px;
    .item {
      width: 100%;
      display: block;
      line-height: 40px;
      margin: 5px 0;
      padding: 15px 5px;
      background-color: $c_mc;
      color: $c_nc_1;
      text-align: center;
      border-radius: 3px;
      overflow: hidden;
      // @include mc_txtOverEllipsis;
      cursor: pointer;
      transition: background-color .3s ease-in-out 0s;
      &:hover {
        background-color: lighten($c_mc, 5%);
      }
    }
  }
  .contact-info-wrap {
    margin-top: 20px;
    .contact-info-tab {
      width: 100%;
      border-collapse: collapse;
      tr,
      td {
        padding: 0 15px;
        border: 1px solid $c_nc_4;
      }
      tr {
        height: 40px;
        line-height: 40px;
        td {
          &:nth-child(2n-1) {
            width: 120px;
            text-align: left;
          }
        }
      }
      a {
        display: inline-block;
        color: #0089ce;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Welcome.vue?5f06bd58